import { render, staticRenderFns } from "./BodyCard.vue?vue&type=template&id=578a9da7&"
import script from "./BodyCard.vue?vue&type=script&lang=js&"
export * from "./BodyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports